import { TuiSvgModule } from '@taiga-ui/core';
import { Component, inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { selectCartTotalNewItemsByUserId } from '@us/web/cart/data-access';
import { Store } from '@ngrx/store';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { AsyncPipe, NgIf } from '@angular/common';
import { selectTurnOnTheStoreChainLinkFeature } from '@us/web/shop/data-access';
import { selectPersistedUserId } from '@us/web/auth/data-access';
import { Router } from '@angular/router';

@Component({
    selector: 'us-tabs',
    templateUrl: './tabs.page.html',
    styleUrls: ['./tabs.page.scss'],
    standalone: true,
    imports: [IonicModule, TranslocoModule, AsyncPipe, TuiSvgModule, NgIf]
})
export class TabsPage {
    private readonly store = inject(Store);
    public readonly router = inject(Router);

    private readonly currentUserId$ = this.store.select(selectPersistedUserId);
    readonly totalNewItems$ = this.currentUserId$.pipe(
        switchMap(userId => this.store.select(selectCartTotalNewItemsByUserId(userId)))
    );
    readonly turnOnTheStoreChainLinkFeature$ = this.store.select(selectTurnOnTheStoreChainLinkFeature);
}
